import React, { useEffect, useState } from "react";
import moment from "moment";
import { Select, DatePicker, Space, Divider, Button, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import Dropzone from "../../Dropzone/Dropzone";
import { fetchCurrenciesDic } from "../../../store/slices/rtkDictionaries";
import "./StatementUploadForm.less";

const StatementUploadForm = ({ cancel, sendFile, isUploading }) => {
  const dispatch = useDispatch();
  const { dicCurrencies = { id: null, name: null } } = useSelector(
    (state) => state.rtkDictionaries
  );
  const { tenant } = useSelector((state) => state.tenants);
  const currencyId = tenant.defaultCurrencyId;

  const [form] = Form.useForm();

  const currentDate = moment();

  useEffect(() => {
    dispatch(fetchCurrenciesDic());
  }, [dispatch]);

  const [fileSelected, setFileSelected] = useState(false);

  const onUpdateFile = (file) => {
    setFileSelected(Boolean(file));
    form.setFieldsValue({ file });
  };

  const initialValues = {
    fromDate: currentDate,
    currencyId,
    file: null,
  };

  if (!currencyId) return null;

  return (
    <>
      <Form
        initialValues={initialValues}
        form={form}
        labelCol={{ span: 3 }}
        wrapperCol={{ span: 16 }}
        style={{ padding: "30px 30px 60px" }}
        onFinish={sendFile}
      >
        <Form.Item
          label="Дата выписки"
          name="fromDate"
          labelAlign="left"
          rules={[{ required: true }]}
          className="form-item-required__hidden-error"
        >
          <DatePicker
            format="DD.MM.YYYY"
            disabledDate={(value) => value.isAfter(currentDate, "day")}
          />
        </Form.Item>
        <Form.Item label="Валюта" name="currencyId" labelAlign="left">
          <Select
            className="upload-statement__select"
            style={{ width: "200px" }}
            placeholder="-- Выберите валюту --"
            disabled
          >
            {dicCurrencies.map(({ id, name }) => (
              <Select.Option value={id} key={id} className="option">
                {name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Файл" name="file" labelAlign="left">
          <div className="statements__form_row">
            <Dropzone updateFile={onUpdateFile} disabled={isUploading} />
          </div>
        </Form.Item>
      </Form>
      <Divider className="divider_thin" />
      <Space className="buttons-container" size="large" align="center">
        <Button onClick={cancel} style={{ width: "108px" }}>
          Отмена
        </Button>
        <Button
          htmlType="button"
          type="primary"
          onClick={form.submit}
          loading={isUploading}
          style={{ width: "108px" }}
          disabled={!fileSelected || isUploading}
        >
          Сохранить
        </Button>
      </Space>
    </>
  );
};

export default StatementUploadForm;
